<template>
    <v-container v-resize="onResize">
        <v-layout row wrap pt-4 align-center>
            <v-flex xs12 md6>
                <h1>Electorates</h1>
            </v-flex>
            <v-flex xs12 offset-md2 md4>
                <v-text-field :class="{mobileTextField: isMobile}" v-if="!this.loading" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                <v-menu v-if="!this.loading && this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                    <v-btn outline small slot="activator">
                        Sort <v-icon>sort</v-icon>
                    </v-btn>
                    <v-list>
                        <v-subheader>Sort by:</v-subheader>
                        <v-list-tile v-for="(item, index) in HEADERS.filter(h => h.text != '' && h.sortable != false)" :key="item.value" @click="changeSort(item.value)">
                            <v-list-tile-title>
                                {{ item.text }}
                                <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-flex>
        </v-layout>
        <template>
            <v-card v-show="loading">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div class="loader"></div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
            <br>
        </template>
        <div v-show="!loading">
            <v-data-table :headers="HEADERS"
                        :footer-props="FOOTERS"
                        :items="ELECTORATES"
                        :rows-per-page-items="ROWS_LISTITEMS"
                        :pagination.sync="PAGINATION"
                        :hide-headers="isMobile"
                        :custom-sort="customSort"
                        :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                        v-on:update:pagination="UPDATE_PAGINATION"
                        :search="search" class="elevation-1">

                <template v-slot:items="props">
                    <router-link class="tr" v-if="isMobile" :to="{ name: $store.state.ROUTE_ELECTORATE, params: { Electorate: props.item.Electorate, State: props.item.State}}">
                        <td>
                            <div class="flex-content">
                                <div class="flex-item">
                                    <div class="flex-item">
                                        <h3 class="pb-xs-1">{{ props.item.Electorate }}</h3>
                                    </div>
                                    <div class="flex-item flex-item-col flex-item-col" data-label="State">{{ props.item.State }}</div>
                                    <div class="flex-item flex-item-col flex-item-col-25" data-label="Established">{{ props.item.Established | stringDateFormat }}</div>
                                    <div class="flex-item flex-item-col flex-item-col-25" data-label="Ceased">
                                        <span v-if="props.item.Ceased">{{ props.item.Ceased | stringDateFormat }}</span>
                                        <span v-if="!props.item.Ceased">N/A</span>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </router-link>
                    <router-link v-else class="tr" :to="{ name: $store.state.ROUTE_ELECTORATE, params: { Electorate: props.item.Electorate, State: props.item.State}}">
                        <td class="text-xs-left">{{ props.item.Electorate }}</td>
                        <td class="text-xs-left">{{ props.item.State }}</td>
                        <td class="text-xs-right">{{ props.item.Established | stringDateFormat }}</td>
                        <td class="text-xs-right">
                            <span v-if="props.item.Ceased">{{ props.item.Ceased | stringDateFormat }}</span>
                            <span v-if="!props.item.Ceased">N/A</span>
                        </td>
                    </router-link>
                </template>

                <template v-slot:no-results>
                    <v-alert :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </template>

            </v-data-table>

            <v-btn class="csvButton_hide" color="secondary" v-on:keyup.enter="EXPORTTOCSV()" v-if="ELECTORATES.length">
                <v-icon aria-hidden="true" class="mr-1">text_snippet</v-icon>
                <span @click="EXPORTTOCSV()">Download as CSV</span>
            </v-btn>
        </div>
        <br />
    </v-container>
</template>

<script>
    window.scrollTo(0, 0);
    import axios from 'axios'
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;    

    export default {
        data() {
            return {
                isMobile: false,
                loading: true,
                search: '',
                ELECTORATES: [],
                CSV_HEADERS: ['Electorate', 'State', 'Established', 'Ceased'],
                CSV_FILENAME: "Handbook-Electorates",

                ROWS_LISTITEMS: [5, 10, 50, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],

                PAGINATION: {
                    rowsPerPage: this.$store.state.ROWS_PER_PAGE,
                    sortBy: 'Ceased',
                    descending: true,
                },

                HEADERS: [{
                    text: 'Electorate',
                    value: 'Electorate',
                    align: 'left',
                    sortable: true,
                },
                {
                    text: 'State',
                    value: 'State',
                    align: 'left',
                    sortable: true,
                },
                {
                    text: 'Date Established',
                    value: 'Established',
                    align: 'right',
                    sortable: true,
                    sort: (a, b) => this.$moment(a) > this.$moment(b)
                },
                {
                    text: 'Date Ceased',
                    value: 'Ceased',
                    align: 'right',
                    sortable: true,
                    sort: (a, b) => this.$moment(a) > this.$moment(b)
                },
                ],

                FOOTERS: {
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus',
                },
            }
        },

        created() {
            this.loadElectorates();
        },
        mounted() {
            this.onResize();
            //Set page to 10 on mobile, only on mount
            if (this.isMobile){
                this.PAGINATION.rowsPerPage = 10;
            }
        },
        methods: {
            onResize() {
                if (window.innerWidth < 769){
                    this.isMobile = true;
                }
                else{
                    this.isMobile = false;
                }
            },
            changeSort(column) {
                if (this.PAGINATION.sortBy === column) {
                    this.PAGINATION.descending = !this.PAGINATION.descending
                } 
                else {
                    this.PAGINATION.sortBy = column
                    this.PAGINATION.descending = false
                }
            },
            loadElectorates() {
                this.loading = true;
                const url = "electorates?$select=Electorate,State,Established,Ceased&apply=$filter=Electorate ne ''";
                axios.get(`api/${url}`)
                    .then(response => {
                        this.ELECTORATES = response.data.value;
                        this.loading = false;
                    });
            },
            EXPORTTOCSV() {
                this.$gtag.event('electorates download csv', {
                    'event_category': 'downloads',
                    'event_label': 'electorates search csv download',
                    'value': 1
                });
                this.$store.dispatch('GETCSV', { DATA: this.ELECTORATES, HEADERS: this.CSV_HEADERS, FILENAME: this.CSV_FILENAME })
            },

            UPDATE_PAGINATION: function (options) {
                this.$gtag.event('electorates pagination items per page', {
                    'event_category': 'filters',
                    'event_label': `items per page: ${options.rowsPerPage}`,
                    'value': 1
                });
                this.$gtag.event('electorates pagination page', {
                    'event_category': 'filters',
                    'event_label': `page: ${options.page}`,
                    'value': 1
                });
                this.$gtag.event(`electorates sorting`, {
                    'event_category': 'sorting',
                    'event_label': `sort by ${options.sortBy} ${options.descending ? 'DESC' : 'ASC'}`,
                    'value': 1
                });
                return this.PAGINATION;
            },

            TRACK_SEARCH: function () {
                if (this.search.length >= 3) {
                    this.$gtag.event('filter electorates - search', {
                        'event_category': 'filters',
                        'event_label': this.search,
                        'value': 1
                    });
                }
            },
            
            customSort(items, index, isDesc) {
            items.sort((a, b) => {
                if (index === 'Established' || index == null) {
                    if (!isDesc && index != null) {
                        const aService = a.Established;
                        const bService = b.Established;
                        return aService < bService ? -1 : 1;
                    } 
                    else if (index == null) {
                        const aService = a.Established;
                        const bService = b.Established;
                        return aService > bService ? -1 : 1;
                    } 
                    else {
                        const aService = a.Established;
                        const bService = b.Established;
                        return bService < aService ? -1 : 1;
                    }
                }
                else if (index === 'Ceased') {
                    if (isDesc) {
                        const aService = a.Ceased;
                        const bService = b.Ceased;
                        if (bService == null || bService == '' || bService == '0001-01-01T00:00:00' || bService == '1900-01-01T00:00:00') {
                            return 1;
                        }
                        else if (aService == null || aService == '' || aService == '0001-01-01T00:00:00' || aService == '1900-01-01T00:00:00') {
                            return -1;
                        }
                        return aService < bService ? 1 : -1;
                    } else {
                        const aService = a.Ceased;
                        const bService = b.Ceased;
                        if (bService == null || bService == '' || bService == '0001-01-01T00:00:00' || bService == '1900-01-01T00:00:00') {
                            return -1;
                        }
                        else if (aService == null || aService == '' || aService == '0001-01-01T00:00:00' || aService == '1900-01-01T00:00:00') {
                            return 1;
                        }
                        return bService < aService ? 1 : -1;
                    }
                }
                else {
                    if (!isDesc) {
                        return a[index] < b[index] ? -1 : 1;
                    } else {
                        return b[index] < a[index] ? -1 : 1;
                    }
                }
            });
            return items;
        }, 
        }
    }
</script>

<style lang="stylus" scoped>
    .v-progress-circular {
        margin: 1rem
    }

</style>
